import { render, staticRenderFns } from "./EMDR.vue?vue&type=template&id=205100ae&scoped=true&"
import script from "./EMDR.vue?vue&type=script&lang=js&"
export * from "./EMDR.vue?vue&type=script&lang=js&"
import style0 from "./EMDR.vue?vue&type=style&index=0&id=205100ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205100ae",
  null
  
)

export default component.exports